import { forwardRef } from 'react';
import './FaceIdentityBrandLogo.css';

const FaceIdentityBrandLogo = forwardRef(function FaceIdentityBrandLogo(
  {
    showLogo,
    orgLogoUrl,
    onLogoError,
    className = '',
    imgClassName = '',
    fallbackClassName = '',
    alt = 'Enterprise',
  },
  ref,
) {
  return (
    <div ref={ref} className={`fi-brand-logo ${className}`.trim()}>
      {showLogo ? (
        <img
          src={orgLogoUrl}
          alt={alt}
          className={`fi-brand-logo__img ${imgClassName}`.trim()}
          onError={onLogoError}
        />
      ) : (
        <p className={`fi-brand-logo__fallback ${fallbackClassName}`.trim()}>enterprise</p>
      )}
    </div>
  );
});

export default FaceIdentityBrandLogo;
